const saleMathods = {
  getDeliverySlots: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/Delivery',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['city', 'street', 'homeNum', 'products'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getTimeSlotsFromDate: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/TechFromDateCountDays',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [
      'fromDate',
      'city',
      'cityCode',
      'streetCode',
      'entranceNo',
      'taskType',
      'callId',
      'postCode',
      'CountDays',
      'captchaToken',
      'flowType',
      'otpPhone',
      'distributionType',
      'infrastructure',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  MyDeliveries: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/MyDeliveries',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getIbcTimeSlots: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/IbcTechnician',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['fromDate', 'addDays', 'citySemel'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  lockIBCTechnician: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/LockIBCTechnician',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  updateDelivery: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/UpdateOrCancel',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'Ban',
      'DispatchOrder',
      'NoteOrder',
      'deliveryRequestAction',
      'NewCity',
      'NewStreet',
      'NewHome',
      'NewApartment',
      'NewDeliveryDate',
      'NewRoundFrom',
      'NewRoundTo',
      'UserName',
      'PhoneForDelivery',
      'PhoneForDelivery2',
      'PickLocation',
      'Round',
      'Comments',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getDeliverySlotsNoProd: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Slots/GetDeliverySlotsLimited',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['city', 'street', 'homeNum', 'slotTimeNoteOrder', 'slotTimeDate', 'slotTimeFrom'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  doTvActivationCodeRecovery: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/activationCodeRecovery',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['source', 'tvassetexternalid', 'tvpsid'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getSubscriberRegistrationStatus: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/GetSubscriberRegistrationStatus',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['tvSubscriber', 'shouldCreateJsonParameters', 'connectClientName'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getJsonParametersBySubscriber: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/getJsonParametersBySubscriber',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['tvSubscriber', 'connectClientName'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getTokenBeforeRedirect: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'ecommerce/connectTokenToSession',// need to change route by what ofir will guide me later, currently for testing using ecommerce route
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'connectClientName',
      'subscriberNumber',
      'idNumber',
      'jsonParameters',
      'hash',
      'sid',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getDisneyPlusTokenBeforeRedirect: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'disney/connectTokenToSession',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [
      'connectClientName',
      'subscriberNumber',
      'idNumber',
      'sub',
      'jsonParameters',
      'hash',
      'sid',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getTvCode: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/GetTvCode',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  tvActivationCodeRecoverySms: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/TvActivationCodeRecoverySms',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  generateUserPasswordTv: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'TvUserAction/GenerateUserPasswordTv',
    httpMethod: 'post',
    isJsonRequest: true,
    // getArgumentName: ['ban', 'activationCode'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  doCallBack: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CallBack',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['IdNumber', 'PhoneNumber', 'SubjectCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createIvrCallback: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CallBack/IvrCallback',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['phoneNumber', 'subjectCode'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  Ban: {
    online: true,
    requiredLogin: false,
    apiSuffixName: '',
    isDualAuthentication: true,
    endPointContext: {
      AUTHENTICATED: {
        apiSuffixName: 'Ban/CreateBanWithAuthentication',
      },
      ANONYMOUS: {
        apiSuffixName: 'Ban/Create',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getEntityDetailsInfo: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ban/GetEntityDetailsInfo',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['SubscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  emailIsExist: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'EmailVacancy/GetEmailVacancy',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['eMailAddress'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  CheckIdNumber: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CheckIdNumber/Check',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['idNumber', 'captchaToken'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getFiberStatus: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/GetFiberAddressStatus',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['city', 'street', 'homeNum', 'apartment'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  checkFiberAddressInfraStructure: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/CheckFiberAddressInfraStructure',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['city', 'cityCode', 'street', 'streetCode', 'streetGisSemel', 'homeNum', 'entry', 'apartment'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  createFiberSequence: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/CreateFiberSequence',
    httpMethod: 'put',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  preSaleCheck: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/GetFiberAddress',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  lockIipOrder: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/LockIipOrder',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createFiberOrder: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/CreateFiberOrder',
    timeout: 40000,
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  CustomerExposure: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Ban/CustomerExposure',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [
      'IdNumber',
      'FirstName',
      'LastName',
      'ProductType',
      'ProductCount',
      'ProductAmount',
      'captchaToken',
      'flowType',
      'otpPhone',
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getReplacedBansBySaleType: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Ban/GetReplacedBansBySaleType',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['saleType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getPhoneNumbers: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'NumbersManagement/GetNumberPhone',
    enableRecaptcha: true,
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['regularNumbersCount', 'prettyNumbersCount'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getPhoneNumbersSaleJet: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Cellular/GetNumberPhone',
    enableRecaptcha: true,
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  reservePhoneNumber: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'NumbersManagement/ReservePhone/reservePhoneNumber',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  reservePhone: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Cellular/ReservePhone',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getCustomerAddresses: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Address/GetCustomerAddresses',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['saleType', 'isBanPackage', 'isCustomerBasedPackage', 'productMakat', 'isFamilyPackage'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getJetCustomerAddresses: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Address/GetCustomerAddresses',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getCities: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Address/GetCities',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['Value'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getStreetsByCity: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Address/GetStreets',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['city'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getZipCode: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Address/GetZipCode',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['street', 'city', 'houseNum', 'entrance'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  makeSale: {
    online: true,
    requiredLogin: false,
    apiSuffixName: '',
    isDualAuthentication: true,

    endPointContext: {
      AUTHENTICATED: {
        apiSuffixName: 'MakeSale/CreateSale',
      },
      ANONYMOUS: {
        apiSuffixName: 'MakeSale/CreateSale',
      },
    },
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getCustomerInfra: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'MakeSale/GetCustomerInfra',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['idNumber', 'captchaToken', 'flowType', 'otpPhone'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  createLead: {
    online: true,
    requiredLogin: false,
    enableRecaptcha: true,
    apiSuffixName: 'Lead/CreateLead',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [
      'recaptchaToken',
      'fullName',
      'phoneNumber',
      'sfCampaignCode',
      'sfCampaignName',
      'sfProductId',
      'adSource',
      'url',
      'bannerId',
      'searchTerm',
      'isAgreementsCheckBoxActive',
      'description',
      'customerIdNumber'
    ],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  sendExtendedLead: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Lead/ExtendedLead',
    httpMethod: 'put',
    isJsonRequest: true,
    getArgumentName: [
      'recaptchaToken',
      'blockId',
      'firstName',
      'lastName',
      'identity',
      'payment',
      'phoneNumber',
      'additionalPhone',
      'email',
      'companyName',
      'content',
      'generalField',
      'terms',
      'subject',
      'uploadFiles',
      'isAgreementsCheckBoxActive',
      'utmParams'
    ],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkIsServiceCenterActive: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Lead/ServiceCenterActive',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['blockId'],
    headers: {
      'Content-Type': 'application/json',
    },
    //error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  createMovingLeadAction: {
    online: false,
    requiredLogin: false,
    apiSuffixName: 'Lead/creatMovingLead',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['reqData'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  creditCardValidation: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CreditCard/Validation',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['creditCardType', 'creditCardNumber', 'idNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  ibcUpdateOrderData: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/IbcUpdateOrderData',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['internalRequestId', 'ibcCustExists'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getTvSubscriptions: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PremiumPackages/GetTvSubscriptions',
    httpMethod: 'get',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getSocList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PremiumPackages/getSocList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  premiumPackageAction: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PremiumPackages/premiumPackageAction',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: ['subscriberId', 'productId', 'action', 'subscriberNo', 'socName', 'socTitle', 'dayDuration'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  checkCellcomEnergy: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'CellcomEnergy/CheckCellcomEnergy',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getTimeSlots: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/TechAddHours',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [
      'city',
      'cityCode',
      'streetCode',
      'entranceNo',
      'taskType',
      'callId',
      'postCode',
      'captchaToken',
      'flowType',
      'otpPhone',
      'addHours',
      'distributionType',
      'infrastructure',
      'houseNumber',
      'apartment'
    ],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getSaleDetailsAuth: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'MakeSale/GetSaleDetailsAuth',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['saleType', 'recaptchaToken'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getSaleDetailsOtp: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'MakeSale/GetSaleDetailsOtp',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['saleType', 'subscriberNo', 'identity', 'otpTicketId', 'recaptchaToken'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getSaleCatalog: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'SaleCatalog/GetSaleCatalog',
    isDualAuthentication: true,
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getSalePrices: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'SaleCatalog/GetSalePrices',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkUser: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'SaleCatalog/checkUser',
      },
      AUTHENTICATED: {
        apiSuffixName: 'SaleCatalog/checkUserAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['isCustomerExists', 'id', 'firstName', 'lastName', 'saleType'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createSale: {
    online: true,
    requiredLogin: false,
    apiSuffixName: '',
    isDualAuthentication: true,
    endPointContext: {
      AUTHENTICATED: {
        apiSuffixName: 'SaleCatalog/CreateSaleAuth',
      },
      ANONYMOUS: {
        apiSuffixName: 'SaleCatalog/CreateSale',
      },
    },
    httpMethod: 'post',
    timeout: 240000,
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },

  getTechnicianTimes: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/GetTechnicianTimes',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createTouristESim: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'TouristESim/createTouristESim',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: ['offerId', 'passportId'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getFirstTechnicianTime: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Slots/GetFirstTechnicianTime',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getTVSubscribers: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'PremiumPackages/GetTVSubscribers',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPremiumPackagesSalePrices: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SaleCatalog/GetSalePrices',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  premiumPackageCatalogAction: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SaleCatalog/CreateSaleAuth',
    httpMethod: 'post',
    timeout: 50000,
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPhoneNumberInfo: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Cellular/GetEntityDetailsInfo',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['SubscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPriceSim: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Cellular/GetPriceSim',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['idNumber', 'bpKey'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPriceSimBusiness: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Cellular/GetPriceSim',
    httpMethod: 'get',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: ['idNumber', 'bpKey', 'amdgrp'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getDeliverySimPrice: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Cellular/GetDeliverySimPrice',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['idNumber'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkBezeqInfrastructure: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Fiber/CheckBezeqInfrastructure',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkJetOpenOrders: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SaleCatalog/CheckJetOpenOrders',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['ban'],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getCellularFullPrice: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    apiSuffixName: 'Cellular/GetOderPrice',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getFullPrice: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'SaleCatalog/GetFullPrice',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getQrCode: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Cellular/GetQrCode',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  openOpportunity: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Lead/OpenOpportunity',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getPriceEsimByUserParameters: {
    online: true,
    requiredLogin: false,//TODO:change this to true
    apiSuffixName: 'Cellular/GetPriceEsimByUserParameters',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createEsimOrder: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SaleCatalog/CreateEsimOrder',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getQrCodeUpgrade: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Cellular/GetQrCodeUpgrade',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  checkUserAfterLogin: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'SaleCatalog/CheckUserAfterLogin',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  sendSecondMagicLink: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Cellular/SendSecondMagicLink',
    httpMethod: 'post',
    isJsonRequest: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  energySaleGetOrderPrice: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Energy/GetOrderPrice',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Energy/GetOrderPriceAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  energySaleCreateSale: {
    online: true,
    requiredLogin: false,
    isDualAuthentication: true,
    endPointContext: {
      ANONYMOUS: {
        apiSuffixName: 'Energy/CreateSale',
      },
      AUTHENTICATED: {
        apiSuffixName: 'Energy/CreateSaleAuth',
      },
    },
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createEnergySignatureFile: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Energy/CreateEnergySignatureFile',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  getEnergySignatureFileStatus: {
    online: true,
    requiredLogin: false,
    apiSuffixName: 'Energy/GetEnergySignatureFileStatus',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  uploadIdfVerificationFile: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IdfDiscount/UploadVerificationFile',
    httpMethod: 'post',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getSubscribersByProduct:{
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Subscribers/GetSubscribersByProduct',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: ['saleType'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getMyProduct:{
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Subscribers/GetMyProduct',
    httpMethod: 'get',
    isJsonRequest: true,
    enableRecaptcha: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{ code: '009', description: 'ארעה שגיאה' }],
  },
  getEnergyReplacePrices: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Energy/GetEnergyReplacePrices',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
  createEnergyReplace: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Energy/CreateEnergyReplace',
    httpMethod: 'post',
    isJsonRequest: false,
    enableRecaptcha: true,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
  },
};

export default saleMathods;
